module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat2-074dcb9d1914f2e984892849ae029d74.svg";